import { useEffect, useRef, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Spin, Upload } from 'antd';

import Heading from '@/components/reusable/heading';

import { companyApiEndpoints } from '@/api/endpoints';

import { handleUpdatePostApi } from '@/api/crud';
import { imageToBase64 } from '@/utils/common';
import { rules } from '@/utils/validation/FormValidation';
import { normFile, onPreview } from './common';

import DateField from '@/utils/date/Date';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { AntButton } from '@/common/ant-components/AntButton';

const EditCompany = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm(); //Form hooks for managing hooks state
  const [fileList, setFileList] = useState([]);
  const [photo, setPhoto] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const backRef = useRef();
  const createRef = useRef();

  const controller = new AbortController();

  useEffect(() => {
    const signal = controller.signal;
    async function handleCompanyDetailsOnLoad() {
      try {
        setLoading(false);
        const res = await companyApiEndpoints.retrieve(id, signal);

        if (res.data.data) {
          const company = res.data.data;

          if (company) {
            form.setFieldsValue(company);

            if (!company.photo) return;
            setPhoto(`data:image/png;base64,${company?.photo}`);
          }
        }
      } catch (error) {
        throw new Error(error);
      }
    }

    handleCompanyDetailsOnLoad();

    return () => {
      controller.abort();
    };
  }, [id]);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const navigateToList = () => {
    navigate('/company/list/');
  };
  // const normFile = (e) => {
  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   return e?.fileList;
  // };

  useEffect(() => {
    form.getFieldInstance('name').focus();
  }, []);

  return (
    <>
      <section className="">
        <Card>
          <Form
            form={form}
            onFinish={async (value) => {
              let base64Photo;
              if (value.photo && value.photo[0]?.originFileObj) {
                const file = value.photo[0].originFileObj; // Get the actual file object
                base64Photo = await imageToBase64(file);
              }

              handleUpdatePostApi(
                id,
                companyApiEndpoints.update,
                {
                  ...value,
                  photo: base64Photo ? base64Photo : photo,
                  // financialYearStart: value?.financialStart,
                  // financialYearEnd: value?.financialEnd,
                },
                setLoading,
                form,
                () => {},
                navigateToList,
              );
            }}
            layout="vertical"
          >
            <Spin spinning={loading}>
              <GlobalDivider name="Edit Company" />
              <div>
                <Row gutter={[16, 16]}>
                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Company Name"
                      name="name"
                      rules={rules.textOnly}
                      hasFeedback
                      validateTrigger="onChange"
                    >
                      <Input
                        onKeyDown={(e) => {
                          if (e.code === 'Tab' && e.shiftKey) {
                            e.preventDefault();
                            backRef.current.focus();
                          }
                        }}
                        placeholder="Company Name"
                        autoComplete="off"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Address"
                      name="address"
                      hasFeedback
                      rules={rules.required}
                      validateTrigger="onChange"
                    >
                      <Input autoComplete="off" placeholder="Address" />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div>
                <Row gutter={[16, 16]}></Row>
              </div>

              <div className="flex justify-end">
                <div className="flex gap-2">
                  <AntButton
                    ref={createRef}
                    className="submit-button"
                    htmlType="submit"
                  >
                    Update
                  </AntButton>

                  <AntButton
                    color="red"
                    className="cancel-button"
                    ref={backRef}
                    onClick={() => navigate('/company/list/')}
                    onKeyDown={(e) => {
                      if (e.code === 'Tab' && e.shiftKey) {
                        e.preventDefault();
                        createRef.current.focus();
                        return;
                      }
                      if (e.code === 'Tab') {
                        e.preventDefault();
                        form.getFieldInstance('name').focus();
                      }
                    }}
                  >
                    Back
                  </AntButton>
                </div>
              </div>
            </Spin>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default EditCompany;
